import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "service" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "service__content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Услуги Автосервиса", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ADropdown = _resolveComponent("ADropdown")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_ADropdown, {
          title: "Техническое обслуживание",
          list: _ctx.maintenance
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Тормозная система",
          list: _ctx.brakeSystem
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Электрооборудование",
          list: _ctx.electrical
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Ходовая часть",
          list: _ctx.chassis
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Рулевое управление",
          list: _ctx.steering
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Двигатель",
          list: _ctx.engine
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Коробка передач",
          list: _ctx.transmission
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Выхлопная система",
          list: _ctx.exhaust
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Охлаждение, Обогрев",
          list: _ctx.heater
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Система кондиционирования",
          list: _ctx.airConditioner
        }, null, 8, ["list"]),
        _createVNode(_component_ADropdown, {
          title: "Малярные и кузовные работы",
          list: _ctx.bodyWork
        }, null, 8, ["list"])
      ])
    ])
  ]))
}